import { render, staticRenderFns } from "./ForumGroupSlideImageDetail.vue?vue&type=template&id=6d33e854&scoped=true&"
import script from "./ForumGroupSlideImageDetail.vue?vue&type=script&lang=js&"
export * from "./ForumGroupSlideImageDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d33e854",
  null
  
)

export default component.exports